import api from "../config/Api";
import { config } from "../config/host";
import Cookies from "js-cookie";

export const Auth = {
  async isAuthenticated() {
    const token = Cookies.get("token");
    const user = Cookies.get("user");

    if (!token || !user) return false;
    return true;
  },

  async login(email, password, cb) {
    try {
      const response = await api.post("/api/login", { email, password });
      const { token, user } = response.data.data;

      // simpan ke cookies
      Cookies.set("token", token, { expires: 1 }); // 7 hari
      Cookies.set("user", JSON.stringify(user), { expires: 1 });

      if (cb) cb(false, user);
    } catch (err) {
      console.error("Login error:", err);
      if (cb) cb(err);
    }
  },

  async loginWithOTP(phone_number, otp, cb) {
    try {
      const response = await api.post("/api/otp/verify", { phone_number: phone_number, otp: otp });
      
      const { token, user } = response.data.data;

      // simpan ke cookies
      Cookies.set("token", token, { expires: 1 }); // 7 hari
      Cookies.set("user", JSON.stringify(user), { expires: 1 });

      if (cb) cb(false, user);
    } catch (err) {
      console.error("Login error:", err);
      if (cb) cb(err, []);
    }
  },

  async register(payload, cb) {
    try {
      const response = await api.post("/api/register", payload);
      if (cb) cb();
    } catch (err) {
      console.error("register error:", err);
      if (cb) cb(err);
    }
  },

  async loginWithGoogle(idToken, cb) {
    try {
      const response = await api.post("/api/google-login", { id_token: idToken });
      const { token, user } = response.data;

      Cookies.set("token", token, { expires: 1 });
      Cookies.set("user", JSON.stringify(user), { expires: 1 });

      if (cb) cb();
    } catch (err) {
      console.error("Login with Google failed:", err);
      if (cb) cb(err);
    }
  },

  async RegisterWithGoogle(idToken, cb) {
    try {
      const response = await api.post("/api/auth/google-register", { id_token: idToken });
      if (cb) cb(null, response);
    } catch (err) {
      console.error("Register with Google failed:", err);
      if (cb) cb(err, null);
    }
  },

  async logout(cb) {
    try {
      const token = Cookies.get("token");

      if (token) {
        await api.post(
          "/api/logout",
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      Cookies.remove("token");
      Cookies.remove("user");

      window.location.href = `/login`;
      if (cb) cb();
    } catch (err) {
      console.error("Logout error:", err);
      Cookies.remove("token");
      Cookies.remove("user");
      if (cb) cb();
    }
  },

  getUser() {
    const user = Cookies.get("user");
    return user ? JSON.parse(user) : null;
  },

  getToken() {
    return Cookies.get("token");
  },
};
